/**
 * Shifts Components Index
 * 
 * These components are extracted from the main Shifts.jsx for better modularity.
 */
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';

export { default as SortableMassnahmeRow } from './SortableMassnahmeRow';
export { default as ShiftDialog } from './ShiftDialog';
export { default as MassnahmeDialog } from './MassnahmeDialog';
export { default as ActivityDialog } from './ActivityDialog';
export { default as ImportDialog } from './ImportDialog';
export { default as CopyShiftDialog } from './CopyShiftDialog';
export { MassnahmenListTab } from './MassnahmenListTab';

// Helper: Format date to German format (dd.MM.yyyy)
export const formatDateDE = (dateStr) => {
  if (!dateStr) return '';
  try {
    return format(parseISO(dateStr), 'dd.MM.yyyy', { locale: de });
  } catch {
    return dateStr;
  }
};

// Activity types constant
export const ACTIVITY_TYPES = [
  { value: 'berufsschule', label: 'Berufsschule', color: '#3B82F6' },
  { value: 'praktikum', label: 'Praktikum', color: '#10B981' },
  { value: 'exkursion', label: 'Exkursion', color: '#F59E0B' },
  { value: 'pruefung', label: 'Prüfung', color: '#EF4444' },
  { value: 'sonstiges', label: 'Sonstiges', color: '#EAB308' },
];
